import {
  BarcodeOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  DownloadOutlined,
  InboxOutlined,
  ShopOutlined,
  UploadOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";

import {
  Alert,
  AutoComplete,
  Avatar,
  Button,
  Checkbox,
  Drawer,
  Form,
  Input,
  message,
  Select,
  Spin,
  Tag,
} from "antd";
import { ReactElement, useCallback, useEffect, useRef, useState } from "react";

import axios from "axios";
import { authenticateToken } from "../../../utils/auth";
import { getImgUrl, getParamValue } from "../../../utils/index";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import { useLocation } from "react-router";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import { debounce } from "lodash";
import CampaignLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";
import { useSelector } from "react-redux";
import React from "react";
// @ts-ignore
import builkcsv from "../../../demo-files/products.csv";
import * as d3 from "d3";
import Dragger from "antd/lib/upload/Dragger";

type CSVData = {
  products: any[];
};

const { Option } = Select;

const CampaignProductList = (params): ReactElement => {
  const router = useLocation();
  const page = getParamValue(router?.search, "page");
  const [form] = Form.useForm();
  const fetchRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [fetchedCSVData, setFetchedCSVdata] = useState<CSVData | null>();

  // --------------------------------
  const [checkedList, setCheckedList] = React.useState([]);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);
  const [selectedProductBarcode, setSelectedProductBarcode] = useState<any>([]);
  // --------------------------------

  const simpleFileDownload = () => {
    window.location.href = `${builkcsv}`;
  };
  // --------------------------------
  const { campaignInfo } = useSelector((state) => (state as any)?.authReducer);
  const campaignId = campaignInfo?.id;
  const [drawerVisible, setDrawerVisible] = useState(undefined);
  const [status, setStatus] = useState("");
  const [limit, setLimit] = useState(50);
  const [minimumStock, setMinimumStock] = useState<any>(10000000);
  const [type, setType] = useState(campaignInfo?.type);
  const [key, setKey] = useState("");
  const [barCode, setBarCode] = useState("");
  const [isActive, setIsActive] = useState("");
  const [activeSearch, setActiveSearch] = useState(undefined);

  const [brandId, setBrandId] = useState<any>();
  const [parentCatId, setParentCatId] = useState();
  const [categoryId, setCategoryId] = useState<any>();
  const [supplierId, setSupplierId] = useState<any>();
  const [hubId, setHubId] = useState(getParamValue(router.search, "hubId"));
  const [shopId, setShopId] = useState(getParamValue(router.search, "shopId"));
  // --------------------------------

  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [parentCatOptions, setParentCatOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [hubsOptions, setHubsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [shopProductData, setShopProductData] = useState({
    loading: false,
    data: null,
  });

  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const reseAllFieldData = () => {
    setKey("");
    setBarCode("");
    setType("");
    setCategoryId("");
    setBrandId("");
    setSupplierId("");
    setHubId("");
    setShopId("");
    setMinimumStock(10000000);
    setIsActive(null);
    form.resetFields();
  };

  // **********************************
  // Search Options
  // **********************************
  const getParentCategoryOptions = useCallback(
    async (val?: string) => {
      setParentCatOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/parent-by-type?page=0&limit=20` +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setParentCatOptions({
        loading: false,
        list: res?.data?.categories?.map((category) => {
          return {
            value: category?.id,
            label: category?.title,
          };
        }),
      });
    },
    [type]
  );

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      if (parentCatId) {
        setCategoriesOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-parent?page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (parentCatId ? `&categoryId=${parentCatId}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.id,
              label: category?.title,
            };
          }),
        });
      } else {
        setCategoriesOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-by-type?page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.id,
              label: category?.title,
            };
          }),
        });
      }
    },
    [type, parentCatId]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  const getHubsOptions = useCallback(
    async (val?: string) => {
      setHubsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/hub/all?page=0&limit=20` +
          (val ? `&name=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setHubsOptions({
        loading: false,
        list: res?.data?.hubs?.map((hub) => {
          return {
            value: hub?.id,
            label: hub?.name,
          };
        }),
      });
    },
    [type]
  );

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop?page=0&limit=30` +
          (val ? `&key=${val}` : ``) +
          (hubId ? `&hubId=${hubId}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            value: shop?.id,
            label: shop?.name,
          };
        }),
      });
    },
    [hubId, type]
  );

  const getProductByBarcodeOptions = useCallback(
    async (bCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?page=0&limit=20&deleted=${false}` +
          (bCode ? `&barCode=${bCode}` : ``) +
          (campaignId ? `&campaignId=${campaignId}` : ``) +
          (key ? `&key=${key}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any; barCode: any }) => {
          return {
            value: product?.barCode,
            label: product?.name,
          };
        }),
      });
    },
    [status, type, key, isActive, campaignId]
  );

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      setProductOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?page=0&limit=20&isDeleted=${false}` +
          (val ? `&key=${val}` : ``) +
          (campaignId ? `&campaignId=${campaignId}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any }) => {
          return {
            value: product?.name,
            label: product?.name,
          };
        }),
      });
    },
    [campaignId, barCode, type, isActive, status]
  );

  const getCampaignProduct = useCallback(
    (getCampaignId) => {
      if (getCampaignId) {
        try {
          setShopProductData({ loading: true, data: undefined });
          axios
            .get(
              `${
                process.env.REACT_APP_CATALOG_READER_API
              }/admin/product?campaignId=${getCampaignId}&isDeleted=${false}` +
                `&page=${page || 0}` +
                `&limit=${limit || 16}` +
                (key ? `&key=${key}` : ``) +
                (isActive ? `&isActive=${isActive}` : ``) +
                (barCode ? `&barCode=${barCode}` : ``) +
                (supplierId ? `&supplierId=${supplierId}` : ``) +
                (categoryId
                  ? `&categoryId=${categoryId}`
                  : parentCatId
                  ? `&categoryId=${parentCatId}`
                  : ``) +
                (hubId ? `&hubId=${hubId}` : ``) +
                (shopId ? `&shopId=${shopId}` : ``) +
                (brandId ? `&brandId=${brandId}` : ``) +
                (minimumStock ? `&minimumStock=${minimumStock}` : ``) +
                (type ? `&type=${type}` : ``),
              {
                headers: {
                  Authorization: `Bearer ${authenticateToken()}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              if (data.status === 200) {
                setShopProductData({
                  loading: false,
                  data: data?.data,
                });

                setCheckedList(
                  data.data.products.map((product) => product?.barCode)
                );
              } else {
                setShopProductData({ loading: false, data: null });
                responseNotification(
                  data.statusText || "something went wrong",
                  "error"
                );
              }
            })
            .catch((err) => {
              setShopProductData({ loading: false, data: null });

              console.log(err);
            });
        } catch (error) {
          setShopProductData({ loading: false, data: null });

          console.log(error, "error");
        }
      }
    },

    [
      limit,
      page,
      supplierId,
      parentCatId,
      categoryId,
      brandId,
      key,
      barCode,
      type,
      isActive,
      minimumStock,
      hubId,
      shopId,
    ]
  );
  // **********************************
  // Search Options
  // **********************************

  const onChange = (e) => {
    setSelectedProductBarcode((prevVal: any) => {
      const newVal = e;
      let newArr = Array.from(prevVal);
      const found = prevVal.find((item) => item === newVal);
      if (!found) {
        newArr.push(newVal);
      } else {
        newArr = newArr.filter((item) => item !== newVal);
      }
      return newArr;
    });

    setIndeterminate(
      !!checkedList.length &&
        checkedList.length <= selectedProductBarcode.length
    );
    setCheckAll(checkedList.length === selectedProductBarcode.length);
  };

  const onCheckAllChange = (e) => {
    setSelectedProductBarcode(e.target.checked ? checkedList : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "product") getProductOptions(value);
        else if (field === "productByBarcode")
          getProductByBarcodeOptions(value);
        else if (field === "parentCategory") getParentCategoryOptions(value);
        else if (field === "category") getCategoriesOptions(value);
        else if (field === "brand") getBrandsOptions(value);
        else if (field === "hub") getHubsOptions(value);
        else if (field === "shop") getShopsOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getParentCategoryOptions,
    getCategoriesOptions,
    getBrandsOptions,
    getProductOptions,
    getProductByBarcodeOptions,
    getHubsOptions,
    getShopsOptions,
  ]);

  const onSubmit = async (data) => {
    setLoading(true);
    const readyData = data && {
      campaignId: campaignId,
      barCodeShopIds: fetchedCSVData?.products?.map((product, i) => ({
        barCode: product?.barCode,
        shopId: product?.shopId,
      })),
    };

    await fetch(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/campaign/add-products`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Products assigned Successfully", "success");
          onClose();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const onRemove = async (data) => {
    setLoading(true);
    const readyData = data && {
      campaignId: campaignId,
      barCodes: selectedProductBarcode || [],
    };

    await fetch(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/campaign/remove-products`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(readyData),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification("Products removed Successfully", "success");
          onClose();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  useEffect(() => {
    getCampaignProduct(campaignId);
  }, [getCampaignProduct, campaignId]);

  useEffect(() => {
    if (supplierId) {
      getCampaignProduct(campaignId);
    }
  }, [campaignId, getCampaignProduct, supplierId]);

  useEffect(() => {
    if (activeSearch) {
      getParentCategoryOptions();
      getCategoriesOptions();
      getBrandsOptions();
      getHubsOptions();
      getShopsOptions();
    }
  }, [
    getBrandsOptions,
    getParentCategoryOptions,
    getCategoriesOptions,
    getHubsOptions,
    getShopsOptions,
    activeSearch,
  ]);

  useEffect(() => {
    if (parentCatId) {
      setCategoryId("");
      form.resetFields(["sub_category_search"]);
    }
  }, [setCategoryId, parentCatId]);

  useEffect(() => {
    if (hubId) {
      form.resetFields(["shop_search"]);
      setShopId("");
    }
  }, [setShopId, hubId]);

  const handleUpload = async (data) => {
    const filteredData = [];

    data?.forEach((row) => {
      filteredData.push({
        barCode: row.barCode?.trim(),
        shopId: row.shopId?.trim(),
      });
    });

    setFetchedCSVdata({
      products: filteredData,
    });
  };

  const readUploadFile = (val) => {
    const mainFile = val.fileList[0].originFileObj;

    if (mainFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        d3.csv(data).then((res) => {
          handleUpload(res);
          console.log("Products:", res);
        });
      };
      reader.readAsDataURL(mainFile);
    }
  };

  function getShopName() {
    shopsOptions?.forEach((shop) => {
      console.log("shopName: ", shop?.name);
      if (shop?.id === shopId) return shop?.name;
    });
    return "";
  }

  const resetData = () => {
    form?.resetFields();
    setFetchedCSVdata(null);
  };

  const onClose = () => {
    getCampaignProduct(campaignId);
    resetData();
    form?.resetFields();
    setDrawerVisible(undefined);
  };

  const props = {
    name: "file",
    multiple: true,
    action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  return (
    <React.Fragment>
      <CampaignLayout campaignId={campaignId}>
        <>
          <section className="product-lists">
            <div className="product-list-item-area white-bg">
              <ShopHeader
                leftarea={"Product List"}
                rightarea={
                  <div className="d-flex">
                    {activeSearch ? (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(false);
                          reseAllFieldData();
                        }}
                        danger
                      >
                        <ZoomOutOutlined />
                      </Button>
                    ) : (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(true);
                        }}
                      >
                        <ZoomInOutlined />
                      </Button>
                    )}

                    {!selectedProductBarcode?.length ? (
                      <Button
                        type="primary"
                        title="Clone Product"
                        className="mx-2"
                        onClick={() => setDrawerVisible(true)}
                      >
                        <UploadOutlined /> Upload
                      </Button>
                    ) : (
                      <Button
                        type="primary"
                        title="Clone Product"
                        className="mx-2"
                        onClick={() => setDrawerVisible(true)}
                        danger
                      >
                        <CloseOutlined /> Remove
                      </Button>
                    )}
                  </div>
                }
              />

              {activeSearch && (
                <div className="search_area mb-0">
                  <Form form={form} className="search_form">
                    <Form.Item name="barcode_search" initialValue={barCode}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "productByBarcode")}
                        onSelect={(val) => setBarCode(val)}
                        options={productBarcodeOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productBarcodeOptions?.loading ? (
                            <Spin size="small" />
                          ) : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by BarCode"
                          onSearch={(val) => {
                            setBarCode(val);
                          }}
                          enterButton
                          loading={productBarcodeOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>

                    <Form.Item name="product_search" initialValue={key}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "product")}
                        onSelect={(val) => setKey(val.toString())}
                        options={productOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productOptions?.loading ? <Spin size="small" /> : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by Name"
                          onSearch={(val) => {
                            setKey(val);
                          }}
                          enterButton
                          loading={productOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>
                    <Form.Item name="hub_search" initialValue={hubId}>
                      <Select
                        allowClear
                        showSearch
                        // defaultValue={getHubName}
                        placeholder="Filter by Hub"
                        optionFilterProp="children"
                        onChange={(val) => setHubId(val)}
                        onSearch={(e) => handleSearch(e, "hub")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {hubsOptions.list.length ? (
                          <Option value={""}>All Hub</Option>
                        ) : undefined}
                        {hubsOptions?.list?.map((hub) => (
                          <Option value={hub?.value}>{hub?.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item name="shop_search">
                      <Select
                        allowClear
                        showSearch
                        // defaultValue={getShopName}
                        placeholder="Filter by Shop"
                        optionFilterProp="children"
                        onChange={(val) => setShopId(val)}
                        onSearch={(e) => handleSearch(e, "shop")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {shopsOptions.list.length ? (
                          <Option value={""}>All Shop</Option>
                        ) : undefined}
                        {shopsOptions?.list?.map((shop) => (
                          <Option value={shop?.value}>{shop?.label}</Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item name="parentCategory_search">
                      <Select
                        allowClear
                        showSearch
                        placeholder="Filter by Category"
                        optionFilterProp="children"
                        onChange={(val) => setParentCatId(val)}
                        onSearch={(e) => handleSearch(e, "parentCategory")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {parentCatOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item name="sub_category_search">
                      <Select
                        allowClear
                        showSearch
                        placeholder="Sub Category"
                        optionFilterProp="children"
                        onChange={(val) => setCategoryId(val)}
                        onSearch={(e) => handleSearch(e, "category")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {categoriesOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="status_search">
                      <Select
                        showSearch
                        placeholder="Status"
                        onChange={(val) => setIsActive(val as string)}
                      >
                        <Select.Option value="">ALL</Select.Option>
                        <Select.Option value={"true"}>ACTIVE</Select.Option>
                        <Select.Option value={"false"}>INACTIVE</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item name="stock_search">
                      <Select
                        showSearch
                        placeholder="Minimum Stock"
                        onChange={(val) => setMinimumStock(val)}
                      >
                        <Select.Option value="10000000">ALL </Select.Option>
                        <Select.Option value="0">OUT OF STOCK</Select.Option>
                      </Select>
                    </Form.Item>
                  </Form>
                  <div className="search_btn">
                    <Button
                      type="primary"
                      size="large"
                      danger
                      onClick={reseAllFieldData}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              )}

              <div className="">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading major">
                      <Checkbox
                        indeterminate={indeterminate}
                        onChange={onCheckAllChange}
                        checked={
                          checkAll ||
                          selectedProductBarcode?.length === checkedList?.length
                        }
                        className="mr-3"
                      >
                        Check all
                      </Checkbox>
                    </div>
                    <div className="single-product-heading major">
                      <span>Stock & Price</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Shop Name</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Status</span>
                    </div>
                  </div>
                </div>
              </div>

              {shopProductData.loading ? (
                <Loading />
              ) : (
                <div className="product-table">
                  <div className="product-table-area">
                    {shopProductData?.data?.products?.length ? (
                      shopProductData?.data?.products?.map(
                        (product: any, index: number) => (
                          <React.Fragment key={index}>
                            <div className="single-product-wrapper">
                              <div className="single-product major">
                                <Checkbox
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onChange(product?.barCode);
                                  }}
                                  checked={selectedProductBarcode?.find(
                                    (item) => product?.barCode === item
                                  )}
                                  className="mr-3"
                                  value={product?.barCode}
                                />
                                <Avatar
                                  shape="square"
                                  size={50}
                                  src={getImgUrl(product?.productImage)}
                                  className="mr-3"
                                />
                                <span className="name">{product?.name}</span>
                              </div>

                              <div className="single-product major">
                                <div className="">
                                  {product?.variations?.length
                                    ? product?.variations?.map(
                                        (variant, index) => (
                                          <React.Fragment key={index}>
                                            <div className="d-flex justify-content-start mb-1">
                                              {variant?.barCode ? (
                                                <Tag className="d-flex align-items-center">
                                                  <BarcodeOutlined className="mr-1" />{" "}
                                                  {variant?.barCode}
                                                </Tag>
                                              ) : product?.barCode ? (
                                                <Tag className="d-flex align-items-center">
                                                  <BarcodeOutlined className="mr-1" />{" "}
                                                  {product?.barCode}
                                                </Tag>
                                              ) : undefined}
                                              <Tag
                                                color={
                                                  variant?.stock < 10
                                                    ? `red`
                                                    : `green`
                                                }
                                              >
                                                {variant?.variationName?.toUpperCase()}
                                                : <b>{variant?.stock || 0}</b>
                                              </Tag>
                                            </div>
                                            <div className="d-flex justify-content-start mb-1">
                                              <Tag>
                                                MRP{" "}
                                                {variant?.price?.currencyCode}
                                                {variant?.price
                                                  ?.discountedPrice ||
                                                  variant?.price?.mrp}
                                                {variant?.price
                                                  ?.discountedPrice &&
                                                  variant?.price
                                                    ?.discountedPrice !==
                                                    variant?.price?.mrp && (
                                                    <span className="text-danger">
                                                      {" "}
                                                      <del>
                                                        {variant?.price
                                                          ?.currencyCode ||
                                                          "Tk"}
                                                        {variant?.price?.mrp}
                                                      </del>
                                                    </span>
                                                  )}
                                              </Tag>
                                              <Tag>
                                                TP {variant?.price?.tp}{" "}
                                                {variant?.price?.currencyCode}
                                              </Tag>
                                            </div>
                                          </React.Fragment>
                                        )
                                      )
                                    : undefined}
                                </div>
                              </div>

                              <div className="single-product">
                                <ShopOutlined />
                                <span className="name ml-1 text-uppercase">
                                  {product?.shop?.name}
                                </span>
                              </div>

                              <div className="single-product">
                                <span
                                  className={`radius-btn ${
                                    product?.isActive ? "active" : "inactive"
                                  }-btn`}
                                >
                                  {product?.isActive ? "Active" : "Inactive"}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <Empty data="Products" />
                    )}
                  </div>
                </div>
              )}

              <PaginationTwo
                {...shopProductData?.data}
                limit={limit}
                page={shopProductData?.data?.currentPageNumber || 0}
              />
            </div>
          </section>
        </>
      </CampaignLayout>

      <Drawer
        title={
          !selectedProductBarcode.length ? `Upload Products` : `Remove Products`
        }
        onClose={onClose}
        visible={drawerVisible}
        extra={
          !selectedProductBarcode.length ? (
            <Button onClick={simpleFileDownload} type="dashed" shape="round">
              <DownloadOutlined />
              Sample File
            </Button>
          ) : (
            ``
          )
        }
      >
        {selectedProductBarcode?.length ? (
          <Form layout="vertical" onFinish={onRemove} form={form}>
            <Form.Item label="Product Barcodes">
              <Input.TextArea
                value={selectedProductBarcode}
                disabled
                rows={8}
              />
            </Form.Item>

            <div className="buttons-container">
              <Button
                disabled={loading || !selectedProductBarcode.length}
                loading={(loading ? "loading" : undefined) as any}
                type="primary"
                htmlType="submit"
                danger
              >
                <CloseCircleOutlined />
                Remove Items
              </Button>
            </div>
          </Form>
        ) : (
          <Form layout="vertical" onFinish={onSubmit} form={form}>
            <div className="mb-4">
              <Dragger {...props} onChange={readUploadFile}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single or bulk upload. Strictly prohibit from
                  uploading company data or other band files
                </p>
                <Alert
                  message="Upload Only (.csv) File"
                  type="warning"
                  className="m-3"
                />
              </Dragger>
            </div>

            {console.log("Uplaod:", fetchedCSVData?.products)}

            <div className="mb-4">
              {fetchedCSVData?.products?.length >= 0 ? (
                <Alert
                  type="success"
                  message={`Uploaded ${fetchedCSVData?.products?.length} Item(s)`}
                />
              ) : (
                <Alert
                  type="error"
                  message="Please Upload exact format for Campaign"
                />
              )}
            </div>

            <div className="buttons-container">
              <Button
                disabled={loading || !fetchedCSVData?.products?.length}
                loading={(loading ? "loading" : undefined) as any}
                type="primary"
                htmlType="submit"
                className="add-submit-btn text-center mr-2"
              >
                Upload Products
              </Button>
              <Button
                type="ghost"
                htmlType="button"
                onClick={resetData}
                className="reset-submit-btn text-center mr-2"
              >
                Reset
              </Button>
            </div>
          </Form>
        )}
      </Drawer>
    </React.Fragment>
  );
};

export default CampaignProductList;
